import './Navbar.css';
import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { NavData } from './NavData';

const NavBar = () => {
  const [clicked, setClicked] = useState(false);

  const handleClick = () => {
    setClicked(!clicked);
  };
  // eslint-disable-next-line
  const location = useLocation();

  return (
    <nav className="navbar">
      <h1 className="nav-title">
        <a href='/'>
            <i className="fa-solid fa-house-chimney-window"></i> Xavier Guerrero
        </a>
        <span class="tooltip">Home</span>
      </h1>
      <div className="menu-icon" onClick={handleClick}>
        <i className={clicked ? 'fas fa-times' : 'fas fa-bars'}></i>
      </div>
      <ul className={clicked ? 'nav__menu active' : 'nav__menu'}>
        {NavData.map((item, index) => {
            // if (location.pathname === item.path) {
            //     return null;
            // }
          return (
            <li key={index}>
              <a href={item.path} className='nav-links'>
                <i className={item.icon}></i>
                {item.content}
              </a>
            </li>
            
          );
        })}
      </ul>
    </nav>
  );
};

export default NavBar;